import React from "react";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();
  const handleCardClick = (service) => {
    if (service === "mvp") {
      navigate("/mvp-services");
    } else {
      navigate(`/Core-services?service=${service}`);
      // console.log(`Navigating to service: ${service}`);
    }
  };

  return (
    <>
      <section className="services relative min-h-screen bg-gray-900 overflow-hidden" id="services">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          {/* Floating geometric shapes */}
          <div className="absolute top-20 left-20 w-6 h-6 border-2 border-orange-400 rotate-45 animate-pulse"></div>
          <div className="absolute top-32 right-32 w-3 h-3 bg-orange-400 rounded-full animate-bounce" style={{animationDelay: '0.5s'}}></div>
          <div className="absolute top-64 left-64 w-4 h-4 bg-orange-500 rounded-full animate-ping" style={{animationDelay: '1s'}}></div>
          <div className="absolute bottom-32 right-20 w-8 h-8 border-2 border-orange-300 rounded-full animate-pulse" style={{animationDelay: '1.5s'}}></div>
          <div className="absolute bottom-64 left-32 w-5 h-5 border-2 border-orange-400 rotate-45 animate-bounce" style={{animationDelay: '2s'}}></div>
          <div className="absolute top-48 left-1/2 w-2 h-2 bg-orange-400 rounded-full animate-ping" style={{animationDelay: '0.8s'}}></div>
          <div className="absolute bottom-48 right-1/2 w-6 h-6 border border-orange-300 rotate-12 animate-pulse" style={{animationDelay: '1.2s'}}></div>
          <div className="absolute top-16 right-64 w-12 h-12 bg-orange-400 opacity-20 rounded-full animate-pulse" style={{animationDelay: '2.5s'}}></div>
          <div className="absolute bottom-16 left-48 w-3 h-3 border-2 border-orange-500 rotate-45 animate-bounce" style={{animationDelay: '0.3s'}}></div>
          <div className="absolute top-80 right-48 w-4 h-4 bg-orange-300 rounded-full animate-ping" style={{animationDelay: '1.8s'}}></div>
        </div>

        <div className="container mx-auto px-6 py-16 relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-white mb-16 tracking-wide">
            Core Services
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div
              className="service-card group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              onClick={() => handleCardClick("ai")}
            >
              <div className="bg-gray-800 rounded-xl overflow-hidden shadow-xl border border-gray-700 hover:border-orange-400 transition-all duration-300">
                <div className="h-48 bg-gradient-to-br from-orange-400 to-orange-600 relative overflow-hidden">
                  <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-6xl text-white opacity-90">🤖</div>
                  </div>
                  <div className="absolute top-4 right-4 w-3 h-3 bg-white rounded-full animate-pulse"></div>
                  <div className="absolute bottom-4 left-4 w-2 h-2 bg-white rounded-full animate-ping"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-orange-400 transition-colors">
                    AI & Automation
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    Intelligent systems using NLP, voice AI, RAG, automation tools
                    (Make.com, etc)
                  </p>
                </div>
              </div>
            </div>

            <div
              className="service-card group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              onClick={() => handleCardClick("web")}
            >
              <div className="bg-gray-800 rounded-xl overflow-hidden shadow-xl border border-gray-700 hover:border-orange-400 transition-all duration-300">
                <div className="h-48 bg-gradient-to-br from-blue-500 to-purple-600 relative overflow-hidden">
                  <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-6xl text-white opacity-90">🌐</div>
                  </div>
                  <div className="absolute top-4 right-4 w-3 h-3 bg-white rounded-full animate-pulse"></div>
                  <div className="absolute bottom-4 left-4 w-2 h-2 bg-white rounded-full animate-ping"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-orange-400 transition-colors">
                    Web Development
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    Full-stack development using Python, Django, MERN, Next.js
                  </p>
                </div>
              </div>
            </div>

            <div
              className="service-card group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              onClick={() => handleCardClick("mobile")}
            >
              <div className="bg-gray-800 rounded-xl overflow-hidden shadow-xl border border-gray-700 hover:border-orange-400 transition-all duration-300">
                <div className="h-48 bg-gradient-to-br from-green-500 to-teal-600 relative overflow-hidden">
                  <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-6xl text-white opacity-90">📱</div>
                  </div>
                  <div className="absolute top-4 right-4 w-3 h-3 bg-white rounded-full animate-pulse"></div>
                  <div className="absolute bottom-4 left-4 w-2 h-2 bg-white rounded-full animate-ping"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-orange-400 transition-colors">
                    Mobile App Development
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    Cross-platform apps built with React Native and custom backend
                    logic
                  </p>
                </div>
              </div>
            </div>

            <div
              className="service-card group cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
              onClick={() => handleCardClick("resource")}
            >
              <div className="bg-gray-800 rounded-xl overflow-hidden shadow-xl border border-gray-700 hover:border-orange-400 transition-all duration-300">
                <div className="h-48 bg-gradient-to-br from-purple-500 to-pink-600 relative overflow-hidden">
                  <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-6xl text-white opacity-90">👥</div>
                  </div>
                  <div className="absolute top-4 right-4 w-3 h-3 bg-white rounded-full animate-pulse"></div>
                  <div className="absolute bottom-4 left-4 w-2 h-2 bg-white rounded-full animate-ping"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-orange-400 transition-colors">
                    Resource Augmentation
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    On-demand skilled tech professionals to boost your team's
                    velocity
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;